module.exports = __webpack_public_path__ + "static/media/header-960.6ce72e38.webp";